<template>
    <rkm-modal
        extra-large
        persistent
        ref="Modal"
        title="Solicitações de receita"
    >
        <rkm-alert>
            O paciente possui o(s) seguinte(s) registro(s) de solicitação(ões) de receita(s):
        </rkm-alert>

        <rkm-table
            :fields="fields"
            :items="solicitacoesMedicamentos"
            :tbody-tr-class="rowClass"
            sort-by="dataHora"
            hide-filters
            hide-pagination
        >
            <template v-slot:cell(prescricaoId)="{ item }">
                <rkm-form-radio
                    v-if="!item.descartado"
                    :value="item.prescricaoId"
                    inline
                    name="prescricao"
                    v-model="selectedPrescricaoId"
                />
            </template>

            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    :disabled="item.descartado"
                    @click="descartar(item)"
                    color="danger"
                    small
                >
                    Descartar
                </rkm-button>
            </template>
        </rkm-table>

        <template v-slot:footer="{ cancel }">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
            >
                Fechar
            </rkm-button>

            <rkm-button
                :disabled="!!loading || !selectedPrescricaoId"
                @click="dispensar"
                color="primary"
            >
                Dispensar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import { repository, error, formats } from '@/mixins'

// Vuex.
import { mapGetters, mapActions } from 'vuex'

export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        fields() {

            return [
                { key: 'prescricaoId', label: '#', class: 'col-min text-center'},
                {
                    key: 'dataHora',
                    label: 'Data/hora',
                    formatter: v => this.formatDateTime(v),
                    sortable: true,
                    class: 'col-min',
                },
                { key: 'unidadeInfraestrutura', label: 'Unidade', sortable: true },
                { key: 'usuarioNome', label: 'Profissional', sortable: true },
                { key: 'actions', label: 'Ações', class: 'col-min text-center' },
            ]
        }
    },
    created() {

        this.repositories = {
            dispensacao: this.getConectaSusRepository('farmacia.dispensacao')
        }
    },
    data: () => ({
        selectedPrescricaoId: null
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open() {

            this.$refs.Modal.show()
        },
        descartar(solicitacao) {

            this.showDeleteConfirmation(
                'Deseja realmente descartar essa solicitação? Ao confirmar não será mais possível utilizar a mesma.',
                async() => {

                    if (this.selectedPrescricaoId === solicitacao.prescricaoId) {

                        this.selectedPrescricaoId = null
                    }

                    solicitacao.descartado = true
                }
            )
        },
        dispensar() {

            const solicitacao = this.solicitacoesMedicamentos.find(s => s.prescricaoId === this.selectedPrescricaoId)

            this.setLoading()

            this.repositories.dispensacao.getItensSolicitacaoMedicamento(solicitacao.prescricaoId)
                .then(({ data }) => {

                    this.$set(solicitacao, 'itens', data)

                    this.$nextTick().then(() => {

                        this.$emit('click-to-dispensar', solicitacao)
                        this.$refs.Modal.hide()
                    })
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        rowClass(item, type) {

            if (type === 'row' && item && item.descartado) {

                return 'table-danger'
            }
        }
    },
    mixins: [repository, error, formats],
    props: {
        solicitacoesMedicamentos: { type: Array, required: true },
    }
}
</script>